import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent,
  RouterOutlet,
} from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { AuthService } from '../../services/auth.service';
import { ApplicationContextService } from '../../services/application-context.service';
import { Spinner } from '../spinner/spinner';
import { SpinnerService } from '../../services/spinner.service';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-main-app-layout',
  imports: [
    BreadcrumbComponent,
    FooterComponent,
    HeaderComponent,
    RouterOutlet,
    SidebarComponent,
    Spinner,
  ],
  templateUrl: './main-app-layout.component.html',
  styleUrl: './main-app-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainAppLayoutComponent {
  protected closeSidebar = output<void>();
  manualURL = input<string>();
  readonly #authService = inject(AuthService);
  readonly #spinnerService = inject(SpinnerService);
  readonly #router = inject(Router);
  protected sidebarVisible = signal(false);
  protected isMobile = signal(false);
  protected readonly applicationContextService = inject(
    ApplicationContextService,
  );
  public user = signal(this.#authService.getUser());
  public homePageUrl = input<string>();

  constructor() {
    this.#checkScreen();
    this.#subscribeRouterEventsListener();
  }

  @HostListener('window:resize')
  protected onResize(): void {
    this.#checkScreen();
  }

  protected toggleSidebar(): void {
    if (this.isMobile()) {
      this.sidebarVisible.update((value) => !value);
    }
  }

  #subscribeRouterEventsListener(): void {
    this.#router.events
      .pipe(
        tap((event: any) => this.#navigationInterceptor(event as RouterEvent)),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  #checkScreen(): void {
    this.isMobile.set(window.innerWidth < 1024);
    if (!this.isMobile()) {
      this.sidebarVisible.set(true);
    } else {
      this.sidebarVisible.set(false);
    }
  }

  #navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.#spinnerService.show();
    }
    if (event instanceof NavigationEnd) {
      this.#spinnerService.hide();
    }

    if (event instanceof NavigationCancel) {
      this.#spinnerService.hide();
    }
    if (event instanceof NavigationError) {
      this.#spinnerService.hide();
    }
  }
}
